import { render, staticRenderFns } from "./CheckEBS.vue?vue&type=template&id=6a89e663"
import script from "./CheckEBS.vue?vue&type=script&lang=js"
export * from "./CheckEBS.vue?vue&type=script&lang=js"
import style0 from "./CheckEBS.vue?vue&type=style&index=0&id=6a89e663&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports